import { GetStaticProps, NextPage } from "next";

import Container from "src/components/atoms/Container";
import DefaultLayout from "src/components/layouts/DefaultLayout";
import Markdown from "src/components/molecules/Markdown";
import NotFound from "src/pages/404";
import SinglePageService from "src/services/SinglePageService";

const Index: NextPage<{ data: any }> = ({ data }) => {
  if (!data) return <NotFound />;
  return (
    <DefaultLayout seo={data.attributes.seo}>
      <Container className="mt-4 lg:mt-8">
        <Markdown content={data.attributes.body} width="full" />
      </Container>
    </DefaultLayout>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const data = await SinglePageService.getPage({
      contentType: "privacy",
      populate: ["seo"],
    });

    return {
      props: {
        data,
      },
    };
  } catch {
    return {
      props: {
        data: null,
      },
    };
  }
};

export default Index;
